module.exports = __webpack_public_path__ + "static/media/success-icon.bd567e52.png";